import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import { db } from "../../../services/dexie/stores";
import { AlertNotify } from "../../../components/alerts/AlertNotify";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const ModalCupomDesconto = (props: { data, cupom }) => {
  const [open, setOpen] = React.useState(false);
  const [messages, setMessages] = React.useState<string[]>([]);

  const handleClickAgree = () => {
    setOpen(false);
  };

  const handleClose = (
    event: object,
    reason: "backdropClick" | "escapeKeyDown"
  ) => {
    // Impede fechar por clique no fundo ou tecla Esc
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }

    // Aqui você permite o fechamento
    setOpen(false);
  };

  React.useEffect(() => {
    const aplicarDesconto = async () => {
      try {
        const cupomValido = await db.validarCupom(props.cupom);
        const novasMensagens: string[] = [];

        props.data.forEach((moedaPermitida) => {
          if (!moedaPermitida) return;

          const totalMoeda = moedaPermitida.valor * moedaPermitida.quantidade;
          if (totalMoeda < cupomValido.valor) {
            const moeda = moedaPermitida.codIso === "EUSCOM" ? "USD" : moedaPermitida.codIso;
            novasMensagens.push(`Para compras em ${moeda}, o valor mínimo é de R$ ${cupomValido.valor}.`);
          }
        });

        // Atualiza o state com as mensagens
        setMessages(novasMensagens);
      } catch (error) {
        AlertNotify({
          message: "Erro ao aplicar o cupom. Por favor, tente novamente.",
          type: "danger",
        });
      }
    };
    if( props.cupom && props.data.length > 0 ) {
      setOpen(true);
      aplicarDesconto()
    }

  }, [props.data, props.cupom]);

  React.useEffect(() => {
    const handlePopState = (e: PopStateEvent) => {
      // Impede que o modal seja fechado
      if (open) {
        window.history.pushState(null, "", window.location.href);
      }
    };

    if (open) {
      // Cria um novo histórico para "travar" o voltar
      window.history.pushState(null, "", window.location.href);
      window.addEventListener("popstate", handlePopState);
    }

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [open]);

  return (
    <React.Fragment>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        disableEscapeKeyDown
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>Cupom de desconto!</DialogTitle>
        <DialogContent>
          <DialogContentText>
          Para aplicar o cupom de desconto, é necessário que o valor total da compra atenda ao mínimo exigido, conforme a moeda selecionada:
          </DialogContentText>
          <DialogContentText id="alert-dialog-slide-description" className="mt-2">
          {console.log(messages)}
          <ul>
            {messages.map((msg, index) => (
              <li key={index}>{msg}</li>
            ))}
          </ul>

          </DialogContentText>
          <DialogContentText>
          Se o valor total da compra for inferior ao mínimo exigido, <b>o cupom não será aplicado</b>, mesmo que você continue com a finalização da compra.
          </DialogContentText>

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClickAgree}><b>Continuar</b></Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
